/**
 * Returns array of location titles whose beaconDetails contain the given major/minor.
 * @param {Array} locations - Airport locations from Redux
 * @param {number} major - Beacon major
 * @param {number} minor - Beacon minor
 * @returns {string[]} Matched location titles
 */
export const getLocationsForBeacon = (locations, major, minor) => {
    if (!Array.isArray(locations)) return [];

    const m = Number(major);
    const n = Number(minor);
    if (!Number.isFinite(m) || !Number.isFinite(n)) return [];

    return locations
        .filter(
            (loc) =>
                Array.isArray(loc.beaconDetails) &&
                loc.beaconDetails.some(
                    (b) => Number(b.major) === m && Number(b.minor) === n
                )
        )
        .map((loc) => loc.title)
        .filter(Boolean);
};
